import React from 'react';
import { connect } from 'react-redux';
import { NavLink, Route, Switch, withRouter } from 'react-router-dom';
import _ from 'underscore';

import { Modal, UploadOptimalResponses, QuestionForm, Cues, boilerplateFeedback as getBoilerplateFeedback, MassEditContainer } from '../../../Shared/index';
import questionActions from '../../actions/questions';
import {
  submitOptimalResponses,
  saveResponseToCMS,
  massEditDeleteResponses,
  submitMassEditConceptResults,
  submitMassEditFeedback
} from '../../actions/responses';
import { clearDisplayMessageAndError } from '../../actions/display';
import massEditActions from '../../actions/massEdit';
import C from '../../constants';
import EditFocusPointsContainer from '../focusPoints/editFocusPointsContainer.jsx';
import FocusPointsContainer from '../focusPoints/focusPointsContainer.jsx';
import NewFocusPointsContainer from '../focusPoints/newFocusPointsContainer.jsx';
import EditIncorrectSequenceContainer from '../incorrectSequence/editIncorrectSequenceContainer.jsx';
import IncorrectSequenceContainer from '../incorrectSequence/incorrectSequenceContainer.jsx';
import NewIncorrectSequenceContainer from '../incorrectSequence/newIncorrectSequenceContainer.jsx';
import ResponseComponentWrapper from './responseRouteWrapper.jsx';
import TestQuestionContainer from './testQuestion';
import { getQuestionConceptUID } from '../../libs/getQuestionConceptUID'

const icon = `${window.postbuildEnv.CDN_URL}/images/icons/direction.svg`

class Question extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedBoilerplateCategory: '',
      responses: [],
      loadedResponses: false,
      addingNewResponse: false,
      uploadingNewOptimalResponses: false
    }
  }

  newResponseTextRef = React.createRef()
  newResponseFeedbackRef = React.createRef()
  newResponseOptimalRef = React.createRef()

  handleClickStartEditingQuestion = () => {
    const { dispatch, match } = this.props
    const { params } = match
    const { questionID } = params;
    dispatch(questionActions.startQuestionEdit(questionID));
  }

  cancelEditingQuestion = () => {
    const { dispatch, match } = this.props
    const { params } = match
    const { questionID } = params;
    dispatch(questionActions.cancelQuestionEdit(questionID));
  }

  saveQuestionEdits = (vals) => {
    const { dispatch, match } = this.props
    const { params } = match
    const { questionID } = params;
    dispatch(questionActions.submitQuestionEdit(questionID, vals));
  }

  submitOptimalResponses = (responses) => {
    const { dispatch, match, concepts, } = this.props
    const { params } = match
    const { questionID } = params;
    const conceptUID = getQuestionConceptUID(this.getQuestion())
    dispatch(
      submitOptimalResponses(questionID, conceptUID, responses, concepts)
    )
    this.setState({ uploadingNewOptimalResponses: false, })
  }

  getQuestion = () => {
    const { match, questions, } = this.props
    const { params } = match
    const { data, } = questions;
    const { questionID, } = params;
    return data[questionID];
  }

  handleClickAddNewResponse = () => {
    this.setState({ addingNewResponse: true, });
  }

  handleClickUploadOptimalResponses = () => {
    this.setState({ uploadingNewOptimalResponses: true, });
  }

  handleSubmitResponse = () => {
    const { match, dispatch, } = this.props
    const { params } = match
    const { questionID } = params

    const newResp = {
      vals: {
        text: this.newResponseTextRef.current.value,
        feedback: this.newResponseFeedbackRef.current.value,
        optimal: this.newResponseOptimalRef.current.checked,
        questionUID: questionID,
        gradeIndex: `human${questionID}`,
        count: 1,
      }
    };
    this.newResponseTextRef.current.value = null;
    this.newResponseFeedbackRef.current.value = null;
    this.newResponseOptimalRef.current.checked = false;
    dispatch(saveResponseToCMS(newResp.vals));
    this.setState({ addingNewResponse: false, });
  }

  boilerplateCategoriesToOptions = () => {
    return getBoilerplateFeedback().map(category => (
      <option className="boilerplate-feedback-dropdown-option" key={category.description} >{category.description}</option>
    ));
  }

  boilerplateSpecificFeedbackToOptions = (selectedCategory) => {
    return selectedCategory.children.map(childFeedback => (
      <option className="boilerplate-feedback-dropdown-option" key={childFeedback.description}>{childFeedback.description}</option>
    ));
  }

  chooseBoilerplateCategory = (e) => {
    this.setState({ selectedBoilerplateCategory: e.target.value, });
  }

  chooseSpecificBoilerplateFeedback = (e) => {
    if (e.target.value === 'Select specific boilerplate feedback') {
      this.newResponseFeedbackRef.current.value = '';
    } else {
      this.newResponseFeedbackRef.current.value = e.target.value;
    }
  }

  onCloseUploadOptimalResponsesModal = () => this.setState({ uploadingNewOptimalResponses: false })

  onCloseNewResponseModal = () => this.setState({ addingNewResponse: false, })

  renderBoilerplateCategoryDropdown = (onChangeEvent) => {
    const style = { marginRight: '20px', };
    return (
      <span className="select" style={style}>
        <select aria-label="Boilerplate feedback category" className="boilerplate-feedback-dropdown" onChange={onChangeEvent}>
          <option className="boilerplate-feedback-dropdown-option">Select boilerplate feedback category</option>
          {this.boilerplateCategoriesToOptions()}
        </select>
      </span>
    );
  }

  renderBoilerplateCategoryOptionsDropdown = (onChangeEvent, description) => {
    const selectedCategory = _.find(getBoilerplateFeedback(), { description, });
    if (selectedCategory) {
      return (
        <span className="select">
          <select aria-label="Boilerplate feedback" className="boilerplate-feedback-dropdown" onChange={onChangeEvent}>
            <option className="boilerplate-feedback-dropdown-option">Select specific boilerplate feedback</option>
            {this.boilerplateSpecificFeedbackToOptions(selectedCategory)}
          </select>
        </span>
      );
    } else {
      return (<span />);
    }
  }

  renderNewResponseForm = () => {
    const { addingNewResponse, selectedBoilerplateCategory, } = this.state
    if (!addingNewResponse) { return }

    return (
      <Modal close={this.onCloseNewResponseModal}>
        <div className="box">
          <h6 className="control subtitle">Add a new response</h6>
          <label className="label" htmlFor="new-response-text">Response text</label>
          <p className="control">
            <input className="input" id="new-response-text" ref={this.newResponseTextRef} type="text" />
          </p>
          <label className="label" htmlFor="new-response-feedback">Feedback</label>
          <p className="control">
            <input className="input" id="new-response-feedback" ref={this.newResponseFeedbackRef} type="text" />
          </p>
          <label className="label">Boilerplate feedback</label>
          <div className="boilerplate-feedback-dropdown-container">
            {this.renderBoilerplateCategoryDropdown(this.chooseBoilerplateCategory)}
            {this.renderBoilerplateCategoryOptionsDropdown(this.chooseSpecificBoilerplateFeedback, selectedBoilerplateCategory)}
          </div>
          <br />
          <p className="control">
            <label className="checkbox">
              <input ref={this.newResponseOptimalRef} type="checkbox" />
              Optimal?
            </label>
          </p>
          <button className="button is-primary" onClick={this.handleSubmitResponse} type="button">Add Response</button>
        </div>
      </Modal>
    );
  }

  renderEditForm = () => {
    const { questions, match, concepts } = this.props
    const { params } = match
    const { data } = questions
    const { questionID, } = params;
    const question = (data[questionID]);
    if (questions.states[questionID] === C.EDITING_QUESTION) {
      return (
        <Modal close={this.cancelEditingQuestion}>
          <QuestionForm concepts={concepts} question={question} submit={this.saveQuestionEdits} />
        </Modal>
      );
    }
  }

  renderUploadNewOptimalResponsesForm = () => {
    const { uploadingNewOptimalResponses, } = this.state
    if (!uploadingNewOptimalResponses) { return }

    return (
      <Modal close={this.onCloseUploadOptimalResponsesModal}>
        <UploadOptimalResponses submitOptimalResponses={this.submitOptimalResponses} />
      </Modal>
    );
  }

  isLoading = () => {
    const { questions, } = this.props
    return !questions.hasreceiveddata;
  }

  render() {
    const { questions, match, massEdit, children, concepts, dispatch, display, lessons } = this.props
    const { params } = match;
    const { data } = questions
    const { questionID, } = params;
    const question = this.getQuestion();
    if (this.isLoading()) {
      return (<p>Loading...</p>);
    } else if (data[questionID]) {
      const activeLink = massEdit.numSelectedResponses > 1
        ? <NavLink activeClassName="is-active" to={`/admin/questions/${questionID}/mass-edit`}>Mass Edit ({massEdit.numSelectedResponses})</NavLink>
        : <span style={{ color: "#a2a1a1" }}>Mass Edit ({massEdit.numSelectedResponses})</span>

      return (
        <div className="admin-container">
          {this.renderEditForm()}
          {this.renderNewResponseForm()}
          {this.renderUploadNewOptimalResponsesForm()}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h4 className="title" dangerouslySetInnerHTML={{ __html: data[questionID].prompt, }} />
            <h4 className="title" style={{ color: '#00c2a2' }}>Flag: {data[questionID].flag}</h4>
          </div>
          <Cues
            displayArrowAndText={true}
            question={question}
          />
          <div className="feedback-row student-feedback-inner-container admin-feedback-row">
            <img alt="Directions Icon" className="info" src={icon} />
            <p>{data[questionID].instructions || 'Combine the sentences into one sentence.'}</p>
          </div>
          <p className="control button-group" style={{ marginTop: 10, }}>
            <a className="button is-outlined is-primary" onClick={this.handleClickStartEditingQuestion}>Edit Question</a>
            <a className="button is-outlined is-primary" onClick={this.handleClickAddNewResponse}>Add New Response</a>
            <a className="button is-outlined is-primary" onClick={this.handleClickUploadOptimalResponses}>Upload Optimal Responses</a>
          </p>
          <div className="tabs">
            <ul>
              <li><NavLink activeClassName="is-active" to={`/admin/questions/${questionID}/responses`}>Responses</NavLink></li>
              <li><NavLink activeClassName="is-active" to={`/admin/questions/${questionID}/test`}>Play Question</NavLink></li>
              <li><NavLink activeClassName="is-active" to={`/admin/questions/${questionID}/focus-points`}>{data[questionID].focusPoints ? 'Edit' : 'Add'} Focus Points</NavLink></li>
              <li><NavLink activeClassName="is-active" to={`/admin/questions/${questionID}/incorrect-sequences`}>{data[questionID].incorrectSequences ? 'Edit' : 'Add'} Incorrect Sequences</NavLink></li>
              {activeLink && <li>{activeLink}</li>}
            </ul>
          </div>
          <Switch>
            <Route component={EditIncorrectSequenceContainer} path="/admin/questions/:questionID/incorrect-sequences/:incorrectSequenceID/edit" />
            <Route component={NewIncorrectSequenceContainer} path="/admin/questions/:questionID/incorrect-sequences/new" />
            <Route component={IncorrectSequenceContainer} path="/admin/questions/:questionID/incorrect-sequences" />
            <Route component={EditFocusPointsContainer} path="/admin/questions/:questionID/focus-points/:focusPointID/edit" />
            <Route component={NewFocusPointsContainer} path="/admin/questions/:questionID/focus-points/new" />
            <Route component={FocusPointsContainer} path="/admin/questions/:questionID/focus-points" />
            <Route component={TestQuestionContainer} path="/admin/questions/:questionID/test" />
            <Route
              path="/admin/questions/:questionID/mass-edit"
              render={(routeProps) => (
                <MassEditContainer
                  {...routeProps}
                  actions={{
                    clearDisplayMessage: clearDisplayMessageAndError,
                    clearResponses: massEditActions.clearResponsesFromMassEditArray,
                    deleteAll: massEditDeleteResponses,
                    removeResponse: massEditActions.removeResponseFromMassEditArray,
                    submitConceptResults: submitMassEditConceptResults,
                    submitFeedback: submitMassEditFeedback
                  }}
                  dispatch={dispatch}
                  displayError={display.error}
                  displayMessage={display.message}
                  questionID={questionID}
                  selectedResponses={massEdit.selectedResponses}
                />
              )}
            />
            <Route component={ResponseComponentWrapper} path="/admin/questions/:questionID/responses" />
          </Switch>
        </div>
      );
    } else {
      return (
        <p>404: No Question Found</p>
      );
    }
  }
}

function select(state) {
  return {
    concepts: state.concepts,
    display: state.display,
    lessons: state.lessons,
    massEdit: state.massEdit,
    questions: state.questions,
  };
}

export default withRouter(connect(select)(Question));
